import { useState } from "react";
import type { FormEvent } from "react";
import { useMutation } from "@tanstack/react-query";
import { Link } from "react-router";
import { Aviso, Botao, Campo } from "../componentes/ui";
import { CascaPublica } from "../componentes/layout";
import { solicitarRecuperacao } from "../nucleo/api";
import { emailParecePlausivel } from "../nucleo/validacao";
import { useTitulo } from "../nucleo/titulo";

export function Recuperar() {
  useTitulo("Recuperar senha");

  const [email, setEmail] = useState("");
  const [erroLocal, setErroLocal] = useState<string | null>(null);

  const pedido = useMutation({
    mutationFn: (endereco: string) => solicitarRecuperacao(endereco),
  });

  function enviar(evento: FormEvent<HTMLFormElement>) {
    evento.preventDefault();
    setErroLocal(null);
    if (!emailParecePlausivel(email)) {
      setErroLocal("Confira o e-mail: falta o arroba ou o domínio.");
      return;
    }
    pedido.mutate(email.trim());
  }

  /* A confirmação é a MESMA exista o e-mail ou não — é o que impede esta tela de virar um
     verificador de quem tem conta no portal. Por isso ela também não diz "enviamos": diz o
     que acontece se o endereço existir. */
  if (pedido.isSuccess) {
    return (
      <CascaPublica
        titulo="Pedido registrado"
        descricao="Se esse e-mail tiver acesso ao portal, um link para redefinir a senha chega nele em alguns minutos."
        rodape={<Link to="/entrar">Voltar para a entrada</Link>}
      >
        <div data-testid="recuperacao-registrada">
          <Aviso tom="sucesso" className="mb-4">
            O link vale por tempo limitado e serve uma vez só. Se não chegar, confira a caixa
            de spam antes de pedir outro.
          </Aviso>
          <p className="acesso__ajuda m-0">
            A GEOvendas nunca envia a sua senha por e-mail — só um link para você mesmo
            definir uma nova.
          </p>
        </div>
      </CascaPublica>
    );
  }

  return (
    <CascaPublica
      titulo="Recuperar a senha"
      descricao="Informe o e-mail com que você acessa o portal. Enviamos um link para você definir uma senha nova."
      rodape={
        <>
          <Link to="/entrar">Voltar para a entrada</Link>
          <Link to="/">Página inicial</Link>
        </>
      }
    >
      <form onSubmit={enviar} noValidate>
        <Campo
          rotulo="E-mail"
          type="email"
          inputMode="email"
          autoComplete="username"
          placeholder="nome@empresa.com.br"
          value={email}
          onChange={(evento) => setEmail(evento.target.value)}
          disabled={pedido.isPending}
          autoFocus
          obrigatorio
        />

        {erroLocal ? (
          <Aviso tom="erro" className="mb-4">
            {erroLocal}
          </Aviso>
        ) : null}

        {/* Falha de rede é diferente de e-mail inexistente: a primeira a pessoa precisa
            saber para tentar de novo; a segunda ela nunca fica sabendo. */}
        {pedido.isError ? (
          <Aviso tom="erro" className="mb-4">
            Não foi possível registrar o pedido agora. Tente de novo em instantes.
          </Aviso>
        ) : null}

        <Botao type="submit" variante="verde" larguraTotal disabled={pedido.isPending}>
          {pedido.isPending ? "Enviando…" : "Enviar link de recuperação"}
        </Botao>
      </form>
    </CascaPublica>
  );
}
